import { Controller } from "@hotwired/stimulus"
import QRCode from 'qrcode'

export default class extends Controller {
  static values = {
    content: String,
  };

  connect() {
    this.generateQRCode(this.contentValue);
  }

  disconnect() {

  }

  generateQRCode(content) {
    const canvas = this.element;
    QRCode.toCanvas(canvas, content, function (error) {
      if (error) console.error(error);
    });
  }
}
